export function goToNftPath(path) {
  window.open(path, '_blank')
} 